export const CITIZENSHIP = 'statsborgerskap';
export const SECOND_CITIZENSHIP = 'sekundartStatsborgerskap';
export const RESIDENCE_COUNTRY = 'bostedsland';
export const POSTAL_CODE = 'postnummer';
export const NORWAY = 'NOR';
